import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ErpOrder } from '../../models/orderline'
import { AddCartEvent, CartProduct } from '../../../cart/models/cart-models';

@Component({
  selector: 'app-orderline-table',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderlineTableComponent {
  @Input() orders: ErpOrder[]
  @Input() cartProducts: {[_id:string]:CartProduct}
  @Input() currency: string

  @Output() onAddCart = new EventEmitter<AddCartEvent>()

  cartProduct(order: ErpOrder): CartProduct {
    return this.cartProducts[order.product._id]
  }

  addCart($event) {
    this.onAddCart.emit($event)
  }
}
